import React, { useContext, useEffect, useMemo } from 'react';
import './player.css';
import PlayerWrapper from './player_wrapper';
import { Context } from '../../store'
import myata_bg from './../../images/bg1.png'
import gold_bg from './../../images/bg2.png'
import xtra_bg from './../../images/bg3.png'


const Player = (_props) => {
  const imageList = useMemo(() => [myata_bg, gold_bg, xtra_bg], []);

  useEffect(() => {
    imageList.forEach((image) => {
      new Image().src = image;
    });
  }, [imageList]);

  const [state, , playback] = useContext(Context);

  const tabs = useMemo(() => [
    { name: 'Myata', stream: 'myata', zIndex: 15, bg: myata_bg },
    { name: 'Gold', stream: 'gold', zIndex: 14, bg: gold_bg },
    { name: 'xtra', stream: 'myata_hits', zIndex: 13, bg: xtra_bg },
  ], []);

  useEffect(() => {
    const currentTab = tabs.find(t => t.stream === state.stream);
    if (currentTab) {
      document.body.style.backgroundImage = 'url(' + currentTab.bg + ')';
      document.body.style.backgroundSize = 'cover';
      document.body.style.backgroundAttachment = 'fixed';
    }
  }, [state.stream, tabs]);

  const tabClick = (e) => {
    const tabs_elements = document.getElementsByClassName('tab');
    let i = 1;

    for (let tab of tabs_elements) {
      if (e.target === tab) {
        tab.className = 'tab active';
        tab.style = 'z-index: 15;';
        playback.selectStream(tab.id);
      } else {
        tab.className = 'tab ';
        tab.style = 'z-index: ' + (15 - i);
      }
      i += 1;
    };
  }

  return (
    <div className='center-wrapper'>

      <div className='tab-list'>
        <div id='project-support' className='project-support'>Поддержать проект</div>
        {tabs.map((tab) => {
          return <div id={tab.stream} onClick={tabClick} className={'tab ' + (tab.stream === state.stream ? 'active' : '')} style={{ zIndex: tab.zIndex }} value={tab.name} data-bg={tab.bg}>{tab.name}</div>
        })}
      </div>

      <PlayerWrapper />
    </div>
  );
}

export default Player;
